import { render, staticRenderFns } from "./BaseTableSearches.vue?vue&type=template&id=bbd4823c&scoped=true&"
import script from "./BaseTableSearches.vue?vue&type=script&lang=js&"
export * from "./BaseTableSearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd4823c",
  null
  
)

export default component.exports